<template>
  <div class="panel-mobile-menu__submenu-list">
    <menu-item :key="item.key" v-for="child in item.items" :item="child" />
  </div>
</template>

<script>
export default {
  props: ['item'],
}
</script>
